export default "__VITE_ASSET__KYvTmHHz__"